import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const AddToList = createSvgIcon(
  <path d="M2.25 2.25H0V4.5h2.25V2.25ZM24 9H3.75v2.25H24V9Zm-5.625 3.75h2.25v3.375H24v2.25h-3.375v3.375h-2.25v-3.375H15v-2.25h3.375V12.75Zm-5.25 3.375H3.75v2.25h9.375v-2.25ZM0 16.125h2.25v2.25H0v-2.25ZM0 9h2.25v2.25H0V9Zm3.75-6.75H24V4.5H3.75V2.25Z" />,
  'AddToList'
);

export { AddToList };
